<template>
        <div>
          <input type="text" v-model="currentInput">
  
          <div v-if="question.commited && question.correct && paid" class="congratulations">
            Your answer is correct!
          </div>
          <div v-if="question.commited && !question.correct && paid" class="sorry">
            Your answer is incorrect. You Entered {{question.userAnswer}}. Correct answer is {{question.answers_input}}
          </div>
          <div v-if="question.commited && !paid">Answer submitted. Click Continue to proceed.</div>
          <button v-if="!question.commited" @click="answerInput(question)">Submit</button>
          <!-- <button v-if="question.commited && question.explanation_input" @click="showExplanation=true">Show Explanation</button> -->

        </div>
</template>

<script>
import Vue from 'vue'
    export default {
          name: 'acceptable-statement',
          props: ['question', 'paid'],

          data(){
            return {
              currentInput: ""
            }
          },
          methods:{
            selectAcceptableAnswer: function(question, choiceIndex, selected){
              var vm = this;
              question.answers_multiple[choiceIndex].selected = selected;
              Vue.set(question.answers_multiple, choiceIndex, vm.question.answers_multiple[choiceIndex]);
            },
            answerInput: function(question){
                var vm  = this;

                question.userAnswer = vm.currentInput;
                console.log('emitting answer');
                this.$emit('answer', {answer:question.userAnswer} );
            }
          },
          computed: {
            currentAcceptableQuestionAnswer: function(){
              var vm = this;
              var question = vm.question;

              console.log('question', question);
              var correctArray = [];
              var incorrectArray = [];

              for (var i = 0; i < question.answers_multiple.length; i++) {
                  console.log(question.answers_multiple[i]);

                  if(question.answers_multiple[i].is_correct && !question.answers_multiple[i].selected){
                    correctArray.push(String.fromCharCode(i+65) + '-✔');
                  } else if ( !question.answers_multiple[i].is_correct && question.answers_multiple[i].selected) {
                    correctArray.push(String.fromCharCode(i+65) + '-✖' );
                  }

              }

              return correctArray.join(', ');


            }
          }
    }
</script>


// WEBPACK FOOTER //
// InputAnswer.vue?dac510e6